// React Imports
import React, { createContext, useContext } from 'react';

// Custom Hook Imports
import UseUpdateListingForm from '../hooks/UseUpdateListingForm';

// Creates the context to be used with the update listing form
export const UpdateListingFormContext = createContext();

function UpdateListingFormProvider({ children, startPlanOption, customerNumber, modelType }) {
    const {
        showUpdateListingForm,
        isSubmitted,
        isProcessing,
        isSuccessfull,
        errors,
        apiResponseMessage,
        showSuccess,
        showErrors,
        showLoading,
        updateListing,
        handleChange,
        handlePlanChange,
        handleListingTypeChange,
        handleSubmit,
        handleFileChange,
    } = UseUpdateListingForm(startPlanOption, customerNumber, modelType);

    return (
        <UpdateListingFormContext.Provider value={{
            showUpdateListingForm,
            isSubmitted,
            isProcessing,
            isSuccessfull,
            errors,
            apiResponseMessage,
            showSuccess,
            showErrors,
            showLoading,
            updateListing,
            handleChange,
            handlePlanChange,
            handleListingTypeChange,
            handleSubmit,
            handleFileChange,
        }}>
            {children}
        </UpdateListingFormContext.Provider>
    );
}

export { UpdateListingFormProvider };